import { render, staticRenderFns } from "./TrainingSessionModalUserCertificate.vue?vue&type=template&id=0c1eb0a5&scoped=true"
import script from "./TrainingSessionModalUserCertificate.vue?vue&type=script&lang=js"
export * from "./TrainingSessionModalUserCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1eb0a5",
  null
  
)

export default component.exports